import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const ScrollReveal = ({ children, threshold=0.4 }) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: threshold } // Trigger when 40% of the element is in view
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: isVisible ? 1 : 0 }} // Fade-in when the element is in view
      transition={{ duration: 0.7 }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
